/**
 * Global directives register
 */

/**
 * Removes element from the page if the user in being impersonated.
 */
Vue.directive('impersonate-protect', {
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        if (window.User.is_substitute) {
            if (window.debug) {
                console.log('impersonate-protect - substitute')
            }
        }

        if (window.User.is_impersonating) {
            const commentElement = document.createComment(
                'The element was removed because of impersonate state.'
            )

            el.parentNode.replaceChild(commentElement, el)

            if (window.debug) {
                console.log('The element was removed because of impersonate state.', el)
            }
        }
    }
})

/**
 * Removes element from the page if the user in being impersonated but not by substitute.
 */
Vue.directive('impersonate-protect-exclude-substitute', {
    // When the bound element is inserted into the DOM...
    inserted: function(el) {
        if (window.User.is_impersonating && !window.User.is_substitute) {
            const commentElement = document.createComment(
                'The element was removed because of impersonate state.'
            )

            el.parentNode.replaceChild(commentElement, el)

            if (window.debug) {
                console.log('The element was removed because of impersonate state.', el)
            }
        }
    }
})
